import type {
  BottomSheetItem,
  GroupChannel,
  SendableMessage,
} from "@/crossPlatform/Sendbird";
import { ReactionAddons } from "@/crossPlatform/Sendbird";

interface ReactionsBottomSheetProps {
  channel: GroupChannel;
  message: SendableMessage;
}

const ReactionsBottomSheet = ({
  channel,
  message,
}: ReactionsBottomSheetProps) => {
  const bottomSheetItem: BottomSheetItem = {
    // eslint-disable-next-line react/prop-types
    HeaderComponent: ({ onClose }) => (
      <ReactionAddons.BottomSheet
        channel={channel}
        message={message}
        onClose={onClose}
      />
    ),
    sheetItems: [],
  };

  return bottomSheetItem;
};

export default ReactionsBottomSheet;
